import React from "react";
import styled from "styled-components";

export default function TableScrollGuide() {
  return <Guide><Icon aria-hidden="true">⇆</Icon><span>Shift + 스크롤로 좌우 이동</span></Guide>;
}

const Guide = styled.div`
  display:flex;min-height:30px;align-items:center;justify-content:flex-end;gap:6px;
  margin-bottom:10px;color:#9299a0;font-size:9px;
`;

const Icon = styled.span`
  display:inline-flex;width:20px;height:20px;align-items:center;justify-content:center;
  border:1px solid #e5e8eb;border-radius:5px;background:#f9fafb;color:#777;
  font-size:11px;font-weight:700;
`;
